export enum OddsFormat {
  DECIMAL = "decimal",
  AMERICAN = "american",
  FRACTIONAL = "fractional",
}
